module.exports = __webpack_public_path__ + "static/media/1.0f4ac58f.jpg";